module.exports = __webpack_public_path__ + "img/04-top-img.76e2c796.png";